module.exports = __webpack_public_path__ + "static/about-us-14-03c489b2a294f44033032849b9919566.jpg";